import Vue from 'vue';
import {WinForm} from '@/libs';

Vue.directive('resizeHeight', {
  inserted: function (el: any) {
    if(el.id) {
      let height = WinForm.storge.get(`resize_height_${el.id}`);
      if (height) el.style.height = height;
    }
    el.onmousedown = function (event: any) {
      // $(el).height($(el).height());
      let document = (window as any).document;
      if (!event.path[0].classList.contains("resize_height")) {
        return;
      }
      let originHeight = event.target.offsetHeight/*event.target.offsetHeight*/, originY = event.clientY;
      let height: string;
      document.onmousemove = function (e: any) {
        e.preventDefault();
        e.stopPropagation();
        height = originHeight - (e.clientY - originY) + 'px';
        event.target.style.height = height;
      };

      document.ondragstart = function (e: any) {
        e.preventDefault();
        e.stopPropagation();
      };
      document.ondragend = function (e: any) {
        e.preventDefault();
        e.stopPropagation();
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.ondragstart = null;
        document.ondragend = null;
        document.onmouseup = null;
        if (el.id) {
          WinForm.storge.set(`resize_height_${el.id}`, height);
        }
      };
    }
  }
});